export const SELECT = 'SELECT';
export const CHECKBOX = 'CHECKBOX';
export const TIME_PICKER = 'TIME_PICKER';
export const DATE_PICKER = 'DATE_PICKER';
export const PASSWORD = 'PASSWORD';
export const RADIO = 'RADIO';
export const INPUT = 'INPUT';
export const IMAGE = 'IMAGE';
export const MULTIPLE_SELECT = 'MULTIPLE_SELECT';
export const API_KEY_GENERATOR = 'API_KEY_GENERATOR';
export const POLLING_SCHEDULE = 'POLLING_SCHEDULE';
